import { useDispatch } from 'react-redux';
import { Card, Typography, Button } from 'components';
import { ButtonColors } from 'components/DesignButton/DesignButton';
import { CardErrorBoundaryWithSpinfinity } from 'components/Card/CardErrorBoundaryWithSpinfinity';
import { removeModalOpened } from 'store/modal';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

import replayIllustration from 'assets/images/first_look_replay.png';
import styles from './ReplayFirstLookCard.module.css';

const ReplayFirstLookCardContent = () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();

  const handleReplay = () => {
    trackEvent('First Look', {
      event_type: 'replay_button_clicked',
      button_text: 'Replay your First Look',
      location: 'summary_card',
    });
    const modalIdentifier = {
      name: 'firstLook',
      props: {},
    };
    dispatch(removeModalOpened(modalIdentifier));
  };

  return (
    <Card variant='wrapper' className={styles.card} onClick={handleReplay}>
      <div className={styles.cardContent}>
        <div className={styles.textContent}>
          <Typography variant='heading-m' className={styles.text}>
            Replay your First Look
          </Typography>
          <Button
            label='Watch Again'
            color={ButtonColors.PURPLE}
            size='small'
            iconNameLeft='playFilled'
            className={styles.watchButton}
          />
        </div>
        <img
          src={replayIllustration}
          alt='Replay First Look'
          className={styles.illustration}
        />
      </div>
    </Card>
  );
};

export const ReplayFirstLookCard = () => {
  return (
    <CardErrorBoundaryWithSpinfinity cardName='ReplayFirstLookCard'>
      <ReplayFirstLookCardContent />
    </CardErrorBoundaryWithSpinfinity>
  );
};
